<app-list-billing
     [chunkBookingBilling]="chunkBookingBilling"
     [companyNames]="providers"
     [guideNames]="guides"
     [isAdmin]="true"
     [isGuideBilling]="true"
     (companySelectedTrigger)="onCompanySelectedTrigger($event)"
     (findBillingTrigger)="onFindBillingTrigger($event)"></app-list-billing>
<app-message-panel [preloading]="true"></app-message-panel>